import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { configurableAttributeCodeEngine } from '@df/module-product-configuration/model/configurable/options/engines/configurable-attribute-code.engine';
import { configurableMismatchCodeEngine } from '@df/module-product-configuration/model/configurable/options/engines/configurable-missmatch.engine';
import { configurableStockCodeEngine } from '@df/module-product-configuration/model/configurable/options/engines/configurable-stock.engine';
import { getProductConfigurationProviders } from '@df/module-product-configuration/provider/product-configuration.providers';
import { UiComponent } from '@df/ui/ui.component';
import { BehaviorSubject } from 'rxjs';
import { Product } from '../product.decorator';
import { LocalProductConfigurationBaseService } from '../configuration/local-product-configuration-base.service';
import { ProductConfigurationBaseService } from '@df/module-product-configuration/model/base/product-configuration-base.service';

@Component({
    selector: 'product-view',
    template: `@if (model) {
        <cms-product-view-layout [variant]="model.ppLayoutVariant" [product]="model" [parent]="parent"></cms-product-view-layout>
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: getProductConfigurationProviders({
        component: ProductViewComponent as any,
        metaIntegration: true,
        configurable: () => ({
            order: ['color', 'size'],
            urlModel: 'child',
            metaModel: 'child',
            optionsEngines: [
                configurableMismatchCodeEngine({ logic: 'error' }),
                configurableAttributeCodeEngine({ codes: ['color'], logic: 'include' }),
                configurableStockCodeEngine({ logic: 'error' })
            ]
        }),
        localProviders: [{ provide: ProductConfigurationBaseService, useClass: LocalProductConfigurationBaseService }]
    })
})
export class ProductViewComponent extends UiComponent {
    @Input({
        required: true
    })
    model!: Product<IProductDataV3>;

    protected get parent() {
        return this.model.parent as Product<IProductDataV3>;
    }

    readonly model$ = new BehaviorSubject<Product<IProductDataV3> | undefined>(undefined);

    override ngOnChanges(changes: any): void {
        if (this.model$.value !== this.model) {
            this.model$.next(this.model);
        }
        super.ngOnChanges(changes);
    }
}
